const setProjectIDHome = (payload) => {
  return {
    type: "setProjectIDHome",
    payload,
  };
};

export default setProjectIDHome;
